// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"228":"3e04a4c6","506":"4c2b7fae","707":"490df2d7"}[chunkId] + ".js";
};